import BaseService from "./index";

class UserService extends BaseService {
  static collection = 'users';
}

export default UserService;
